import { Controller } from "@hotwired/stimulus"

const BASE_DURATION_MS = 5000
const STEP_DURATION_MS = 1500
const CLOSE_ANIMATION_MS = 180

// Connects to data-controller="flash-message"
export default class extends Controller {
  static targets = ["progress"]
  static values = { index: Number }

  connect() {
    const duration = BASE_DURATION_MS + (this.indexValue || 0) * STEP_DURATION_MS

    this.element.style.setProperty("--flash-duration-ms", `${duration}ms`)
    this.animationEndHandler = () => this.close()
    this.progressTarget.addEventListener("animationend", this.animationEndHandler)
  }

  disconnect() {
    if (this.animationEndHandler) {
      this.progressTarget.removeEventListener("animationend", this.animationEndHandler)
    }

    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout)
    }
  }

  pause() {
    this.element.classList.add("is-paused")
  }

  resume() {
    this.element.classList.remove("is-paused")
  }

  close(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    if (this.closing) {
      return
    }

    this.closing = true
    this.element.classList.add("is-closing")
    this.closeTimeout = setTimeout(() => this.element.remove(), CLOSE_ANIMATION_MS)
  }
}
